import {
  Briefcase,
  CheckCircle2,
  Tag,
  User,
  type LucideIcon,
} from "lucide-react";
import type { CustomFieldId } from "@/lib/customFieldFilters";

/** A filter that can be added to the task inbox's filter bar: a fixed filter or an opportunity custom field. */
export type InboxFilterKey =
  | "assignee"
  | "opportunity"
  | "type"
  | "completed"
  | CustomFieldId;

/** A selectable filter type shown in the inbox "Add filter" menu and as a chip. */
export interface InboxFilterType {
  key: InboxFilterKey;
  label: string;
  icon: LucideIcon;
}

/** All filter types available on the task inbox, in display order. */
export const INBOX_FILTER_TYPES: InboxFilterType[] = [
  { key: "assignee", label: "Assignee", icon: User },
  { key: "opportunity", label: "Opportunity", icon: Briefcase },
  { key: "type", label: "Type", icon: Tag },
  { key: "completed", label: "Completed", icon: CheckCircle2 },
];

/** Which kind of task the Type filter keeps: agent tasks or onboarding tasks. */
export type InboxTaskType = "agent" | "onboarding";

/** The two choices offered by the Type filter. */
export const INBOX_TASK_TYPE_OPTIONS: {
  value: InboxTaskType;
  label: string;
}[] = [
  { value: "agent", label: "Agent tasks" },
  { value: "onboarding", label: "Onboarding tasks" },
];

/** Whether completed tasks are listed alongside the pending ones. */
export type CompletedVisibility = "hide" | "show";

/** The two choices offered by the Completed filter. */
export const COMPLETED_VISIBILITY_OPTIONS: {
  value: CompletedVisibility;
  label: string;
}[] = [
  { value: "hide", label: "Hide completed" },
  { value: "show", label: "Show completed" },
];
